module.exports = __webpack_public_path__ + "static/media/1.477fe2a1.JPG";